import api from '~/api'

const TYPES = Object.freeze({
});

const stateObject = {
  types: {
    'destination': {
      posts: [],
      post: {},
      footer: [],
      navigation: [],
      sort: [],
      headers: {},
    },
    'accommodation': {
      posts: [],
      post: {},
      footer: [],
      sort: [],
      headers: {},
    },
    'pages': {
      post: '',
      headers: {},
    },
  },
  state: {
    isLoading: 0
  }
};

const getters = {
  getPosts: state => (type='destination') => {
    if(!state.types[type]) {
      return [];
    }
    const result = state.types[type].posts;
    return result;
  },
  getPost: state => (type='destination') => {
    const result = state.types[type].post;
    // console.log(result);
    return result;
  },
  getFooterData: state => (type='destination') => {
    const result = state.types[type].footer;
    return result;
  },
  getNavigationData: state => (type='destination') => {
    const result = state.types[type].navigation;
    return result;
  },
  getHeaders: state => (type='destination') => {
    const result = state.types[type]['headers'];
    return result;
  },
  getState: state => data => {
    return state.state;
  }
};

const mutations = {
  SAVE_POSTS(state, data) {
    const format = data.result.data instanceof Array ? 'posts' : 'post';
  
    if(data.type == 'acc-by-dest') data.type = 'accommodation';

    state.types[data.type][format] = data.result.data;
    state.types[data.type]['headers'] = data.result.headers;
  },
  SAVE_SORT(state, data) {
    const format = data.result.data instanceof Array ? 'posts' : 'post';
    state.types[data.type]['sort'] = format === 'posts' ? data.result.data : [data.result.data];

    // state.types[data.type][format] = data.result.data;
    state.types[data.type]['headers'] = data.result.headers;
  },
  SAVE_FOOTER(state, data) {
    state.types[data.type]['footer'] = data.result.data;
  },
  SAVE_NAVIGATION(state, data) {
    state.types[data.type]['navigation'] = data.result.data;
  },
  SAVE_LOADING(state, data) {
    state.state.isLoading = data
  },
};

const actions = {
  checkPosts({ commit, state }, type) {
    return state.types[type];
  },
  async ['fetchData']({ commit, state }, option) {
    const data = {};

    // ローディングを有効化
    commit('SAVE_LOADING', 1);

    // 記事取得
    data.type = option.type || 'destination';

    data.result = await api.fetchPosts(option)
                            .catch( (error, data) => {
                              if(error) {
                                console.warn(error);
                                window.location.href = '/';
                                return Promise.reject(error);
                              }
                              // console.log('catch', data)
                            });

    // ローディングを解除
    commit('SAVE_LOADING', 0);

    return data;
  },
  async ['fetchPosts']({ commit, dispatch, state }, option={}) {
    const data = await dispatch('fetchData', option);
    commit('SAVE_POSTS', data);
  },
  async ['fetchSort']({ commit, dispatch, state }, option={}) {
    const data = await dispatch('fetchData', option);
    commit('SAVE_SORT', data);
  },
  async ['fetchFooter']({ commit, dispatch, state }, option={}) {
    const data = await dispatch('fetchData', option);
    commit('SAVE_FOOTER', data);
  },
  async ['fetchNavigation']({ commit, dispatch, state }, option={}) {
    const data = await dispatch('fetchData', option);
    commit('SAVE_NAVIGATION', data);
  },
};

export default {
  namespaced: true,
  state: stateObject,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/posts.js